/**
 * Shared helpers for stale-chunk recovery (see ChunkErrorBoundary.jsx).
 * Kept out of the component file so Fast Refresh can treat it as pure JS.
 */

/** Guards one automatic reload per deploy, per tab session. */
export const CHUNK_RELOAD_KEY = "swastik-chunk-reload";

const CHUNK_ERROR_RE = new RegExp(
  [
    "ChunkLoadError",
    "failed to fetch dynamically imported module",
    "error loading dynamically imported module",
    "loading (async )?chunk \\d+ failed",
    "loading css chunk",
    "importing a module script failed",
    "unable to preload css",
    "error during loading",
  ].join("|"),
  "i",
);

const readSession = (key) => {
  try {
    return sessionStorage.getItem(key);
  } catch {
    return null;
  }
};

const writeSession = (key, value) => {
  try {
    sessionStorage.setItem(key, value);
  } catch {
    /* storage unavailable — fall back to manual recovery only */
  }
};

const clearSession = (key) => {
  try {
    sessionStorage.removeItem(key);
  } catch {
    /* ignore */
  }
};

/** The flag a recovered boot leaves behind so a new deploy can retry once. */
export function resetChunkReloadFlag() {
  clearSession(CHUNK_RELOAD_KEY);
}

export function isChunkError(error) {
  if (!error) return false;
  const haystack = `${error.name ?? ""} ${error.message ?? ""} ${
    error.code ?? ""
  }`;
  return CHUNK_ERROR_RE.test(haystack);
}

export function hasPendingChunkReload() {
  return readSession(CHUNK_RELOAD_KEY) !== null;
}

export function markChunkReloadRequested() {
  writeSession(CHUNK_RELOAD_KEY, String(Date.now()));
}